import Img from "../../assets/image/index";
import NewsBgColorsData from "../../js/NewsBgColorsData";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Functions from "./index.function";
import {
  Animatespin,
  Dashboardevents,
  UserDashBoradStatusCom,
  UserdashboradheadingCom,
  LatestNewsCom,
  SearchbarCom,
  Userdetail,
  SidenavbarCom,
} from "../../components/index";
const Dashboard = () => {
  const {
    localThumbnailImgurl,
    localTNewshumbnailImgurl,
    welcomeName,
    baseURL,
    Events,
    isLoading,
    newsList,
    newsisLoading,
    settings,
    PromotionsSliderdata,
    sliderSettings,
    newsSliderSettings,
    updatedDashboardData,
    formatEventDate,
    handleEvents,
    handleNews,
  } = Functions();
  return (
    <div className=" sm:h-screen w-screen flex flex-col pb-2 bg-[#000000]">
      {/* Navbar */}
      <SearchbarCom />
      <div className="grid sm:grid-cols-8 lg:grid-cols-6 xs:pt-10 sm:pt-16 sm:px-2 lg:px-2 xl:px-3">
        {/* Left Sidebar */}
        <div className="sm:col-span-2 lg:col-span-1 xs:z-50">
          <SidenavbarCom />
        </div>

        {/* Center Content (Scrollable) */}
        <div className="sm:col-span-4 lg:col-span-4 scroll-container sm:h-[calc(100vh-4rem)]">
          <div className="w-full col-span-3 xl:pr-8 xl:pl-5 xs:px-1 sm:px-2 lg:px-2">
            <div>
              <div className=" xs:pt-3 sm:pt-4 lg:pt-5 ">
                <h1 className="text-secondary font-unboundedMedium xs:text-lg sm:text-xl lg:text-2xl">
                  Welcome {welcomeName}
                </h1>
              </div>
              <div>
                <h3 className="text-secondary xs:text-sm sm:text-lg lg:text-xl font-onestMedium xs:pb-1.5 sm:pb-2.5 lg:pb-4 xs:pt-6 sm:pt-5 lg:pt-5 xl:pt-8">
                  {/* Features */}
                </h3>
                <div className="grid xs:grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 xs:gap-x-3 xs:gap-y-4 xs:pb-6 sm:pb-8 lg:pb-10 sm:gap-x-4 sm:gap-y-6 lg:gap-y-7">
                  {updatedDashboardData?.map((value, index) => (
                    <div key={index}>
                      <UserDashBoradStatusCom
                        to={value?.to}
                        layout={value?.layout}
                        postion={value?.postion}
                        textsize={value?.textsize}
                        icon={value?.icon}
                        title={value?.title}
                        notification={value?.notification}
                        iconLayout={value?.iconLayout}
                      />
                    </div>
                  ))}
                </div>
              </div>
              <div>
                <h3 className="text-secondary xs:text-sm sm:text-lg lg:text-xl font-onestMedium xs:pb-1.5 sm:pb-2.5 lg:pb-4">
                  {/* Promotions */}
                </h3>
                <div className="xs:pb-6 sm:pb-8 lg:pb-10">
                  <Slider {...settings}>
                    {PromotionsSliderdata?.map((slide, index) => (
                      <img
                        className="w-full xs:h-40 sm:!h-64"
                        key={index}
                        src={slide.image}
                        alt=""
                      />
                    ))}
                  </Slider>
                </div>
              </div>
            </div>
            <div className="xs:pb-4 sm:pb-5 lg:pb-5">
              <div className="xs:pb-3 sm:mb-4">
                <UserdashboradheadingCom
                  title={"News"}
                  to={"/news"}
                  navigatelayout={"cursor-pointer"}
                />
              </div>
              <div>
                {newsisLoading === true ? (
                  <Animatespin />
                ) : (
                  <>
                    <Slider {...sliderSettings}>
                      {newsList?.news?.map((value, index) => (
                        <div
                          key={index}
                          className="xs:!mx-[2px] sm:mx-1 lg:px-0"
                        >
                          <LatestNewsCom
                            onClick={() => handleNews(value?.id)}
                            latestNewsthubmail={
                              value?.hero_image === null
                                ? Img.LatestNews_1
                                : `${baseURL}/${localTNewshumbnailImgurl}/${value?.hero_image}`
                            }
                            latestNewsTitle={value?.news_title}
                            alt={value?.news_title}
                            bgcolor={
                              NewsBgColorsData[index % NewsBgColorsData?.length]
                                .newstheme
                            }
                          />
                        </div>
                      ))}
                    </Slider>
                  </>
                )}
              </div>
            </div>
            <div className="xs:py-4 sm:pb-5 lg:pb-5">
              <div className="xs:pb-3 sm:pb-4">
                <UserdashboradheadingCom
                  title={"Events"}
                  to={"/event"}
                  navigatelayout={"cursor-pointer"}
                />
              </div>
              <div>
                {isLoading === true ? (
                  <Animatespin />
                ) : (
                  <>
                    <Slider {...newsSliderSettings}>
                      {Events?.events?.map((value, index) => (
                        <div key={index}>
                          <Dashboardevents
                            onClick={() => handleEvents(value?.id)}
                            eventthubmail={
                              value?.hero_image === null
                                ? Img.Events_2
                                : `${baseURL}/${localThumbnailImgurl}/${value?.hero_image}`
                            }
                            eventTitle={value?.event_title}
                            evetDate={formatEventDate(value?.event_date)}
                            eventDis={value?.event_type}
                          />
                        </div>
                      ))}
                    </Slider>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Right Sidebar */}
        <div className="xs:px-1 xs:pb-1 xs:pt-3 sm:col-span-2 lg:col-span-1">
          <Userdetail />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
